




























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})
export default class ModalSuccess extends Vue {
  @Prop(Boolean) public readonly visible!: boolean;
  @Prop(String) public readonly description!: string;

  closeModal(): void {
    this.$emit("close");
  }
}
